import { Modes } from '@/utils/enums'

export default () => {
  return {
    dirty: false,
    clearing: false,
    saving: false,
    inserting: false,
    loading: true,
    showingUnsavedDialog: false,
    title: '',
    subtitle: '',
    total: 0,
    errors: [],
    closed: false,
    editing: false,
    columnHeaderMetaData: [],
    selectedRange: null,
    canInsert: false,
    columns: [],
    currentlyEditingCells: [],
    refreshingMetadata: false,
    refreshing: false,
    count: 0,
    mode: Modes.Unknown
  }
}
